// import React from "react";
// import { Container, Row, Spinner } from "reactstrap";

// const Loader = (props) => (
//   <Container fluid className={"d-flex " + props.className}>
//     <Row className="justify-content-center align-self-center w-100 text-center">
//       <Spinner color="primary" />
//     </Row>
//   </Container>
// );

// export default Loader;

import React, { useEffect, useState } from "react";
import { Container, Row, Spinner } from "reactstrap";

const Loader = (props) => {
  const [showLongLoadMessage, setShowLongLoadMessage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLongLoadMessage(true);
    }, 7000); // 7 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container
      fluid
      className={
        "d-flex justify-content-center align-items-center " +
        props.className
      }
      style={{ minHeight: "100%" }}
    >
      <Row className="w-100 text-center">
        <div className="w-100">
          <Spinner color="primary" />

          <div
            style={{
              marginTop: "15px",
              fontSize: "23px",
              color: "#6c757d",
            }}
          >
            Loading data, please wait...
          </div>

          {showLongLoadMessage && (
            <div
              style={{
                marginTop: "10px",
                fontSize: "20px",
                color: "#8a8a8a",
                maxWidth: "400px",
                marginLeft: "auto",
                marginRight: "auto",
                lineHeight: "1.5",
              }}
            >
              Some data requests may require additional processing time.
            </div>
          )}
        </div>
      </Row>
    </Container>
  );
};

export default Loader;